module.exports = __webpack_public_path__ + "static/media/22b.7c63b4bc.jpg";